import styled from 'styled-components';

const HeaderLogoContainer = styled.div`
  width: auto;
  margin-right: 40px;
  height: 80px;
  position: relative;

  .header-logo--img {
    width: 234px;
    height: auto;
    margin-top: 20px;
  }
  .white-logo {
    position: absolute;
    visibility: hidden;
    opacity: 0;
  }
  .tertiary-logo {
    visibility: visible;
    opacity: 1;
  }

  @media (max-width: 1450px) {
    height: 70px;

    .header-logo--img {
      width: 160px;
    }
    .white-logo {
      position: absolute;
      visibility: hidden !important;
      opacity: 0 !important;
    }
    .tertiary-logo {
      visibility: visible !important;
      opacity: 1 !important;
    }
  }

  @media (max-width: 1240px) {
    width: auto !important;
  }

  @media (max-width: 430px) {
    margin-right: 0px;
  }

  @media (max-width: 390px) {
    margin: auto 0;
    height: auto;

    .header-logo--img {
      width: 160px;
      max-width: 100%;
      margin-top: 0px;
    }
  }
`;

export { HeaderLogoContainer };
